import React, { useEffect, useState } from "react";
import OneSignal from "react-onesignal";
import { message } from "antd";
import axios from "axios";
import { AUTH_TOKEN } from "redux/constants/Auth";
import OneSignalService from "services/OneSignalService";

const OneSignalManager = ({ children }) => {
	const [isInitialized, setIsInitialized] = useState(false);
	const [isSubscribed, setIsSubscribed] = useState(false);

	useEffect(() => {
		// TODO: Remover essa linha quando o OneSignal estiver funcionando
		// initializeOneSignal();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const initializeOneSignal = async () => {
		try {
			// Inicializar o OneSignal
			await OneSignal.init({
				appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
				allowLocalhostAsSecureOrigin: true,
				notifyButton: {
					enable: true,
				},
				subdomainName: process.env.REACT_APP_ONESIGNAL_SUBDOMAIN,
			});

			// Verificar se o usuário está logado
			const token = localStorage.getItem("token");
			if (token) {
				await registerUser();
			}

			// Configurar listeners
			setupOneSignalListeners();

			setIsInitialized(true);
		} catch (error) {
			console.error("Erro ao inicializar OneSignal:", error);
		}
	};

	const setupOneSignalListeners = () => {
		// Listener para quando o usuário permite notificações
		OneSignal.on("subscriptionChange", async (isSubscribed) => {
			console.log("Status da inscrição mudou:", isSubscribed);
			setIsSubscribed(isSubscribed);

			if (isSubscribed) {
				await registerUser();
			} else {
				await unregisterUser();
			}
		});

		// Listener para quando uma notificação é recebida
		OneSignal.on("notificationDisplay", (event) => {
			console.log("Notificação recebida:", event);
		});

		// Listener para quando uma notificação é clicada
		OneSignal.on("notificationClick", (event) => {
			console.log("Notificação clicada:", event);
			// Aqui você pode adicionar lógica para navegar para uma página específica
			// baseada nos dados da notificação
		});
	};

	const registerUser = async () => {
		try {
			const playerId = await OneSignal.getUserId();
			if (!playerId) {
				console.log("Player ID não disponível ainda");
				return;
			}

			const token = localStorage.getItem(AUTH_TOKEN);
			if (!token) {
				console.log("Usuário não autenticado");
				return;
			}

			// Registrar o player ID no backend
			await OneSignalService.registerUser(playerId);

			console.log("Usuário registrado no OneSignal com sucesso");
		} catch (error) {
			console.error("Erro ao registrar usuário no OneSignal:", error);
		}
	};

	const unregisterUser = async () => {
		try {
			const token = localStorage.getItem("token");
			if (!token) {
				return;
			}

			// Remover o player ID do backend
			await axios.delete("/api/v1/rest/onesignal/remover", {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			console.log("Usuário removido do OneSignal com sucesso");
		} catch (error) {
			console.error("Erro ao remover usuário do OneSignal:", error);
		}
	};

	const checkSubscriptionStatus = async () => {
		try {
			const isSubscribed = await OneSignal.isPushNotificationsEnabled();
			setIsSubscribed(isSubscribed);
			return isSubscribed;
		} catch (error) {
			console.error("Erro ao verificar status da inscrição:", error);
			return false;
		}
	};

	const requestNotificationPermission = async () => {
		try {
			await OneSignal.showSlidedownPrompt();
		} catch (error) {
			console.error("Erro ao solicitar permissão:", error);
			message.error("Erro ao solicitar permissão para notificações");
		}
	};

	// Função para ser chamada quando o usuário faz login
	const onUserLogin = async () => {
		if (isInitialized) {
			await registerUser();
		}
	};

	// Função para ser chamada quando o usuário faz logout
	const onUserLogout = async () => {
		if (isInitialized) {
			await unregisterUser();
		}
	};

	// Expor funções para uso externo
	React.useImperativeHandle(React.useRef(), () => ({
		onUserLogin,
		onUserLogout,
		checkSubscriptionStatus,
		requestNotificationPermission,
		isSubscribed,
		isInitialized,
	}));

	return <div>{children}</div>;
};

export default OneSignalManager;
